import { render, staticRenderFns } from "./CompletePhysicianProfileModal.vue?vue&type=template&id=23a52fe7"
import script from "./CompletePhysicianProfileModal.vue?vue&type=script&lang=js"
export * from "./CompletePhysicianProfileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports